let subscriber = null;
let activeRequest = null;
let sequence = 0;

const dismissResult = (reason = "close") => ({
  isConfirmed: false,
  isDenied: false,
  isDismissed: true,
  dismiss: reason,
  value: undefined,
});

const normalizeOptions = (titleOrOptions, text, icon) => {
  if (titleOrOptions && typeof titleOrOptions === "object") {
    return { ...titleOrOptions };
  }

  return {
    title: titleOrOptions,
    text,
    icon,
  };
};

const publish = (event) => {
  if (subscriber) subscriber(event);
};

const settle = (id, result) => {
  if (!activeRequest || activeRequest.id !== id) return;
  const request = activeRequest;
  activeRequest = null;
  publish({ type: "close", id });
  request.resolve(result);
};

const SystemAlert = {
  fire(titleOrOptions, text, icon) {
    if (activeRequest) {
      settle(activeRequest.id, dismissResult("replaced"));
    }

    const options = normalizeOptions(titleOrOptions, text, icon);
    const id = ++sequence;

    return new Promise((resolve) => {
      activeRequest = { id, options, resolve };
      publish({ type: "open", request: activeRequest });
    });
  },

  close() {
    if (activeRequest) settle(activeRequest.id, dismissResult("close"));
  },

  showLoading() {
    if (activeRequest) publish({ type: "loading", id: activeRequest.id });
  },

  showValidationMessage(message) {
    if (activeRequest) {
      publish({ type: "validation", id: activeRequest.id, message });
    }
  },

  _confirm(id, value) {
    settle(id, {
      isConfirmed: true,
      isDenied: false,
      isDismissed: false,
      value,
    });
  },

  _dismiss(id, reason = "cancel") {
    settle(id, dismissResult(reason));
  },

  _subscribe(callback) {
    subscriber = callback;
    if (activeRequest) callback({ type: "open", request: activeRequest });

    return () => {
      if (subscriber === callback) subscriber = null;
    };
  },
};

export default SystemAlert;
